var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInverseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.066,
    height: 20.066,
    viewBox: "0 0 20.066 20.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5144",
    "data-name": "Rectangle 5144",
    width: 20.066,
    height: 20.066,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9580",
    "data-name": "Group 9580",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9579",
    "data-name": "Group 9579",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27499",
    "data-name": "Path 27499",
    d: "M10.033,20.066A10.033,10.033,0,1,1,20.066,10.033,10.045,10.045,0,0,1,10.033,20.066m0-17.94a7.906,7.906,0,1,0,7.906,7.907,7.916,7.916,0,0,0-7.906-7.907",
    fill: "#e62e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27500",
    "data-name": "Path 27500",
    d: "M10.033,4.033a1,1,0,0,0-1,1v10a.99.99,0,0,0,1,1,6,6,0,1,0,0-12m0,0a1,1,0,0,0-1,1v10a.99.99,0,0,0,1,1,6,6,0,1,0,0-12",
    fill: "#e62e2e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInverseIcon);
export default __webpack_public_path__ + "static/media/InverseIcon.52e4af54375941115714ed5534c57b42.svg";
export { ForwardRef as ReactComponent };